<template>
  <div class="intro-section mb-5">
    <v-container fluid class="py-5 px-lg-10">
      <v-row class="my-0 mb-5">
        <v-col class='py-0'>
          <v-btn block depressed :ripple='false' color="primary" :outlined='!isEboks' @click='setLogType(LOG_TYPES.EBOKS); setFilterParams()'>
            E-Boks
          </v-btn>
        </v-col>
        <v-col class='py-0'>
          <v-btn block depressed :ripple='false' color="primary" :outlined='!isEmail' @click='setLogType(LOG_TYPES.EMAIL); setFilterParams()'>
            E-MAIL
          </v-btn>
        </v-col>
        <v-col class='py-0'>
          <v-btn block depressed :ripple='false' color="primary" :outlined='!isSMS' @click='setLogType(LOG_TYPES.SMS); setFilterParams()'>
            SMS
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if='isEboks' align="center" class="my-0">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field v-model="visitNumber" label="Visitations nr." @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select v-model="eboksType" :items="eboksTypeList" :disabled="eboksTypeList.length <= 1" item-text="item2" item-value="item1" label="E-Boks type"/>
        </v-col>
      </v-row>
      <v-row v-if='isEmail' align="center" class="my-0">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field v-model="visitNumber" label="Visitations nr." @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select v-model="emailType" :items="emailTypeList" :disabled="emailTypeList.length <= 1" item-text="item2" item-value="item1" label="E-mail type"/>
        </v-col>
      </v-row>
      <v-row v-if='isSMS' align="center" class="my-0">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field v-model="visitNumber" label="Visitations nr." @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-select v-model="smsType" :items="smsTypeList" :disabled="smsTypeList.length <= 1" item-text="item2" item-value="item1" label="Sms type"/>
        </v-col>
      </v-row>
    </v-container>
    <div class="intro-section__bottom-box">
      <div class="d-flex justify-end flex-wrap align-center pa-5">
        <v-btn depressed class="my-1" color="primary" outlined :disabled="tableLoading" @click='clearFilters'>
          <v-icon left size="25" class="mr-4">icon-close</v-icon>
          Reset filtre
        </v-btn>
        <v-btn depressed class="ml-2 my-1" color="primary" :disabled="tableLoading" @click='setFilterParams'>
          <v-icon left size="22" class="mr-4">icon-search</v-icon>
          Søg
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { LOG_TYPES } from '@/constants/logTypes';
  import api from '@/api/api';

  export default {
    name: 'LogsFilter',

    data: function () {
      return {
        visitNumber: '',
        emailType: null,
        smsType: null,
        eboksType: null,
      };
    },

    destroyed: function () {
      this.setLogType(this.LOG_TYPES.EBOKS);
      this.clearFilters();
    },

    computed: {
      LOG_TYPES: function() {
        return LOG_TYPES
      },
      tableLoading: function () {
        return this.$store.state.logs.tableLoading;
      },
      logType: function () {
        return this.$store.state.logs.logType;
      },
      isEmail: function () {
        return this.logType === this.LOG_TYPES.EMAIL;
      },
      isSMS: function () {
        return this.logType === this.LOG_TYPES.SMS;
      },
      isEboks: function () {
        return this.logType === this.LOG_TYPES.EBOKS;
      },
      emailTypeList: function () {
        let defaultItem = [
          {
            item1: null,
            item2: 'Alle',
          },
        ];
        return [...defaultItem, ...this.$store.state.logs.emailTypeList];
      },
      smsTypeList: function () {
        let defaultItem = [
          {
            item1: null,
            item2: 'Alle',
          },
        ];
        return [...defaultItem, ...this.$store.state.logs.smsTypeList];
      },
      eboksTypeList: function () {
        let defaultItem = [
          {
            item1: null,
            item2: 'Alle',
          },
        ];
        return [...defaultItem, ...this.$store.state.logs.eboksTypeList];
      },
    },

    methods: {
      clearFilters: function () {
        this.visitNumber = '';
        this.emailType = null;
        this.smsType = null;
        this.eboksType = null;
        this.$store.commit('logs/updateFilterParams', {});
      },
      setLogType: function(type) {
        this.$store.commit('logs/updateLogType', type);
      },
      setFilterParams: function () {
        let params = {};
        this.visitNumber && (params.visitNumber = this.visitNumber);
        if (this.isEmail) {
          this.emailType?.toString() && (params.emailType = this.emailType);
        }
        if (this.isSMS) {
          this.smsType?.toString() && (params.smsType = this.smsType);
        }
        if (this.isEboks) {
          this.eboksType?.toString() && (params.MessageType = this.eboksType);
        }
        this.$store.commit('logs/updateFilterParams', params);
      }
    },
  };
</script>
